import OriginTypography from './Typography';
import Text from './Text';
import Link from './Link';
import Title from './Title';
import Paragraph from './Paragraph';
var Typography = OriginTypography;
Typography.Text = Text;
Typography.Link = Link;
Typography.Title = Title;
Typography.Paragraph = Paragraph;
export default Typography;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/typography/index.js
// module id = 1182
// module chunks = 0